
    import CompanyLogo from '@/components/Company/CompanyLogo';

    export default {
        name: 'JobCardCover',

        components: {
            CompanyLogo,
        },

        props: {
            companyName: {
                type: String,
                default: '',
            },

            companyLink: {
                type: String,
                default: '',
            },

            logo: {
                type: String,
                default: '',
            },

            bgColor: {
                type: String,
                default: '',
            },

            coverImg: {
                type: String,
                default: '',
            },

            hideLogo: {
                type: Boolean,
                default: false,
            },

            noOverlay: {
                type: Boolean,
                default: false,
            },

            height: {
                type: Number,
                default: 0,
            },
        },

        data() {
            return {
                style: '',
                color: '',
                currentPattern: '',
            };
        },

        created() {
            const defaultBgColor = '#67B144';
            this.color = this.bgColor ? this.bgColor : defaultBgColor;
            const pattern = [
                require('@/assets/img/bg-pattern1.svg'),
                require('@/assets/img/bg-pattern2.svg'),
                require('@/assets/img/bg-pattern3.svg'),
                require('@/assets/img/bg-pattern4.svg'),
            ];
            const matches = this.color.match(/(\d+)/);

            this.currentPattern = pattern[(matches) ? matches[0] % 4 : 1];
        },
    };
